import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { useScreenSize } from '@/hooks';
import styles from './LogoutModal.module.css';

/**
 * LogoutModal Component
 * Custom non-full-screen logout confirmation modal
 * Compact modal for mobile and desktop
 */
const LogoutModal = ({ isOpen, onClose, onConfirm }) => {
  const { isMobile } = useScreenSize();

  return (
    <Dialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content className={`${styles.modal} ${isMobile ? styles.mobile : ''}`}>
          {/* Header */}
          <div className={styles.header}>
            <h2 className={styles.title}>Signing Out</h2>
            <button
              className={styles.closeButton}
              onClick={onClose}
              aria-label="Close modal"
            >
              <X size={20} />
            </button>
          </div>

          {/* Content */}
          <div className={styles.content}>
            <p className={styles.message}>
              Are you sure you want to log out? Check our great promotions and bonuses before you leave!
            </p>
            <div className={styles.buttonContainer}>
              <button
                className={`${styles.button} ${styles.cancelButton}`}
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                className={`${styles.button} ${styles.signOutButton}`}
                onClick={onConfirm}
              >
                Sign Out
              </button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default LogoutModal;
